import React from 'react'

import { VendorCode } from '../../models'
import { PaginatedTableContract } from '../common'
import { Link } from 'react-router-dom'

interface VendorsTableProps extends PaginatedTableContract {
    resources: {
        vendors: VendorCode[]
    }
}

export const VendorsTable = (props: VendorsTableProps) => {
    const { resources } = props
    const { vendors } = resources
    return (
        <table className='table'>
            <tbody>
                <tr>
                    <th>Vendor ID</th>
                    <th>Vendor Code</th>
                </tr>
                {vendors.map((vendor) => (
                    <tr key={vendor.id}>
                        <td>{vendor.id}</td>
                        <td>
                            <Link to={`/suppliers`} state={{ vendorCode: vendor.code }}>
                                {vendor.code}
                            </Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
